export default __webpack_public_path__ + "static/playful_mind-5e62bf3639c9fee58bed94b3c6f3d1a5.png";